if (typeof labels === 'undefined') {
        let labels = document.querySelectorAll('#attrDropdown-2 label');
      labels.forEach(label => {
        label.addEventListener('click', () => toggleDropdown('attrDropdown-2'));
      });
      function updateButtonLabel() {
        const selectedInput = document.querySelector('input[name="Size"]:checked, input[name="SIZE"]:checked')
        const selectedSize = selectedInput?.value;
        document.querySelector('button.dropbtn').textContent = selectedSize;
        console.log("Selected option:", selectedSize, document.querySelector('button.dropbtn'));

        const wishlistButtons = document.querySelectorAll('.js-wishlist-engine')
        wishlistButtons.forEach((wishlistButton) => {
          if (wishlistButton.dataset.product_id === selectedInput.dataset.productId) {
            wishlistButton.dataset.variant_sku = selectedInput.dataset.sku
          }
        })
      }

      const sizeOptions = document.querySelectorAll('input[name="Size"], input[name="SIZE"]');
      console.log(11,sizeOptions)
      sizeOptions.forEach(option => {
          option.addEventListener('change', updateButtonLabel);
      });

      // Initial setup: Update the button text if a size is already selected on page load
      const initiallySelectedSize = document.querySelector('input[name="Size"]:checked,input[name="SIZE"]:checked');
      if (initiallySelectedSize) {
          updateButtonLabel(); // Update button label to reflect the selected size
      }
      function closeDropdownOnClickOutside(event) {
        const dropdown = document.getElementById('attrDropdown-2');
        const button = document.querySelector('button.dropbtn');
        if (!dropdown.contains(event.target) && event.target !== button) {
          dropdown.classList.remove("show");
        }
      }
  

    function toggleDropdown(id) {
      document.getElementById(id).classList.toggle("show");
    }

    function selectOption(value) {
      console.log("Selected option:", value);
    }
    // Add event listener to close dropdown when clicking outside
    document.addEventListener('click', closeDropdownOnClickOutside);
  }